'use strict';

import 'whatwg-fetch';
import { UAParser } from 'ua-parser-js';
import { Base64 } from 'js-base64';

/** Mesage Router */
class MessageRouter {
  constructor(config) {
    this._config = config || {};
    this._url = config.url || 'https://msgrt.ga8.io/collect';
    this._topic_counter = {};
    this._ua = new UAParser().getResult();
    this._init_layout();
  }
  _init_layout = function () {
    let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let h =
      window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    this._layout = {
      w: w - (w % 64),
      h: h - (h % 64),
    };
  };
  send(subtopic, args) {
    this._size = `${this._layout.w} x ${this._layout.h}`;
    let counter = this._topic_counter[subtopic] || 0;
    this._topic_counter[subtopic] = ++counter;
    let base = {
      gmid: this._config.gameId,
      tdmn: this._config.topDomain,
      domn: this._config.domain,
      rfrr: this._config.referrer,
      lthr: this._config.hours,
      ctry: this._config.country,
      dpth: this._config.depth,
      vers: this._config.version,
      trac: this._config.tracking,
      whlb: this._config.whitelabel,
      plat: this._config.platform,
      tpct: counter,
      args: args,
      ttle: document.title,
      size: this._size,
      brnm: this._ua.browser.name,
      brmj: this._ua.browser.major,
      osnm: this._ua.os.name,
      osvr: this._ua.os.version,
      dvmd: this._ua.device.model,
      byld: this._config.byloader,
      bylv: this._config.byloaderVersion,
      imgu: this._config.isMasterGameURL,
      iegu: this._config.isExtHostedGameURL,
      itgu: this._config.isTokenGameURL,
      cmpe: false,
      host: window.location.hostname,
    };

    if (typeof idhb !== 'undefined' && typeof idhb.iabCmpExists() !== 'undefined')
      base.cmpe = idhb.iabCmpExists();

    try {
      base = encodeURIComponent(Base64.encode(JSON.stringify([base])));
      // fetch(this._url + `?tp=com.g8plugin.${subtopic}&ar=${base}&ts=${Date.now()}`);
    } catch (error) {
      console.error(error);
    }
  }
  setGameData(gameData) {
    this._gameData = gameData;
    this._config.country = gameData.ctry;
  }
}

export default MessageRouter;
